import { useLocale } from "src/locales/useLocale.js";
import { useGetBlogFeedQuery } from "./blogFeedApi.js";
import { toNewsItems, toNewsLocale } from "./newsFeed.js";
import { NewsWidgetView } from "./NewsWidgetView.js";

const ROWS_SHOWN = 5;
const POSTS_FETCHED = 20;

export const NewsWidget = () => {
	const { lang } = useLocale();
	const locale = toNewsLocale(lang);
	const { data, isLoading, isError } = useGetBlogFeedQuery({
		locale,
		limit: POSTS_FETCHED,
	});

	return (
		<NewsWidgetView
			locale={locale}
			items={data ? toNewsItems(data.posts, ROWS_SHOWN) : []}
			isLoading={isLoading}
			isError={isError}
		/>
	);
};
